import { YesNoEnum } from '../HouseholdOutgoings/types';

export interface IFullNameForm {
  title: string | null;
  firstName: string;
  lastName: string;
  isNameChanged: YesNoEnum | '';
}

export const TITLE_OPTIONS = ['Mr', 'Mrs', 'Ms', 'Miss', 'Dr', 'Prof.', 'Other'];
